import { render, staticRenderFns } from "./NotasFiscaisForm.vue?vue&type=template&id=412e81d6&scoped=true&"
import script from "./NotasFiscaisForm.vue?vue&type=script&lang=js&"
export * from "./NotasFiscaisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e81d6",
  null
  
)

export default component.exports